import Swal from 'sweetalert2';

export const BaseSwal = Swal.mixin({
  heightAuto: false,
  allowEnterKey: false,
});